export class SendGridDynamicTemplateVersion {
    id: string;
    name: string;
    active: boolean;
    updatedAt?: string;

    constructor(data: {
        id: string;
        name: string;
        active: boolean;
        updatedAt?: string;
    }) {
        this.id = data.id;
        this.name = data.name;
        this.active = data.active;
        this.updatedAt = data.updatedAt;
    }

    static fromJSON(json: any): SendGridDynamicTemplateVersion {
        return new SendGridDynamicTemplateVersion({
            id: json.id,
            name: json.name,
            active: json.active === true || json.active === 1,
            updatedAt: json.updated_at ?? json.updatedAt,
        });
    }
}

export class SendGridDynamicTemplate {
    id: string;
    name: string;
    generation?: string;
    updatedAt?: string;
    versions?: SendGridDynamicTemplateVersion[];

    constructor(data: {
        id: string;
        name: string;
        generation?: string;
        updatedAt?: string;
        versions?: SendGridDynamicTemplateVersion[];
    }) {
        this.id = data.id;
        this.name = data.name;
        this.generation = data.generation;
        this.updatedAt = data.updatedAt;
        this.versions = data.versions ?? [];
    }

    static fromJSON(json: any): SendGridDynamicTemplate {
        return new SendGridDynamicTemplate({
            id: json.id,
            name: json.name,
            generation: json.generation,
            updatedAt: json.updated_at ?? json.updatedAt,
            versions: Array.isArray(json.versions)
                ? json.versions.map((v: any) => SendGridDynamicTemplateVersion.fromJSON(v))
                : [],
        });
    }
}